import { z } from 'zod';

export const GlossarySettingsSchema = z
  .object({
    customerCode: z.string().trim().min(1).optional(),
    tms: z.string().trim().min(1).optional(),
  })
  .strict();

export type GlossarySettings = z.infer<typeof GlossarySettingsSchema>;

export const GLOSSARY_DEFAULTS: Required<GlossarySettings> = {
  customerCode: 'Customer Code',
  tms: 'TMS',
};
